import type { ModuleKey } from "@/lib/adminModules";

export type AdminRole = "super_admin" | "csm" | "admin";

export interface GuideSection {
  /** Stable slug, e.g. "ai-sessions-manual-mode". Used as the React key and for search matching. */
  id: string;
  title: string;
  /** Plain text with line breaks; **bold** markers are rendered literally, no HTML/markdown parser. */
  body: string;
  /** Omit to show this section to every role that can see the module at all. */
  roles?: AdminRole[];
  /** ISO date (yyyy-mm-dd) this section last changed — drives the "new" badge. */
  lastUpdated: string;
}

export interface ModuleGuide {
  moduleKey: ModuleKey;
  overview: string;
  sections: GuideSection[];
}

/** Maps the two AuthContext role booleans to the one role a guide section is written against. */
export function resolveViewerRole(isSuperAdmin: boolean, isCsm: boolean): AdminRole {
  if (isSuperAdmin) return "super_admin";
  if (isCsm) return "csm";
  return "admin";
}
